import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NotificationNORM } from '../../../../../../interfaces/notificationT';

@Component({
  selector: 'app-notification-norm',
  templateUrl: './notification-norm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationNormComponent implements OnInit {
  @Input() notification: NotificationNORM;

  constructor() {
  }

  ngOnInit() {
  }

}
